/* eslint-disable react/jsx-props-no-spreading */
// import { getJSON } from '@folklore/fetch';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import SelectField from './Select';

import styles from '../../../styles/fields/country.module.css';

const optionsCache = {};

const provinces = [
    {
        name: 'Québec',
        alpha2: 'QC',
    },
    {
        name: 'Ontario',
        alpha2: 'ON',
    },
    {
        name: 'Colombie Britannique',
        alpha2: 'BC',
    },
    {
        name: 'Alberta',
        alpha2: 'AB',
    },
    {
        name: 'Manitoba',
        alpha2: 'MB',
    },
    {
        name: 'Saskatchewan',
        alpha2: 'SK',
    },
    {
        name: 'Nouvelle Écosse',
        alpha2: 'NS',
    },
    {
        name: 'Nouveau Brunswick',
        alpha2: 'NB',
    },
    {
        name: 'Terre Neuve et Labrador',
        alpha2: 'NL',
    },
    {
        name: 'Île du Prince Édouard',
        alpha2: 'PE',
    },
    {
        name: 'Territoires du Nord Ouest',
        alpha2: 'NT',
    },
    {
        name: 'Nunavut',
        alpha2: 'NU',
    },
    {
        name: 'Yukon',
        alpha2: 'YT',
    },
];

const propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
};

const ProvinceField = ({ value = null, onChange = null, defaultValue = 'QC', ...props }) => {
    const { locale } = useIntl();
    const [options, setOptions] = useState(optionsCache[locale] || null);

    useEffect(() => {
        if (defaultValue) {
            onChange(defaultValue || 'CA');
        }
    }, [defaultValue]);

    useEffect(() => {
        let canceled = false;
        if (options === null) {
            const newOptions = provinces.map(({ name, alpha2 }) => ({
                label: name,
                value: alpha2.toUpperCase(),
            }));
            optionsCache[locale] = newOptions;
            if (!canceled) {
                setOptions(newOptions);
            }
        }
        return () => {
            canceled = true;
        };
    }, [options, locale]);
    return (
        <div className={styles.container}>
            <SelectField {...props} value={value} onChange={onChange} options={options || []} />
        </div>
    );
};

ProvinceField.propTypes = propTypes;

export default ProvinceField;
